import { IS_PROD_STAGE, SDK_TOKEN } from '@/js/constants';

export const isFancl = () => {
  // To solve https://17media.atlassian.net/browse/HU-1885

  if (IS_PROD_STAGE) {
    return [
      'q2ddzy2e', // prod: 10347, FANCL
      '46k5e86o', // prod: 13581
    ].includes(SDK_TOKEN);
  }

  return false;
};
